export class CancellationReasonModel {
    constructor(public reasonId: number, public cancellationReason: string) {
    }
}
